// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin: 0px 0px;
  min-height: 60px;
  height: auto;
  width: 100%;
}

::ng-deep .page-title {
  min-height: 50px;
  padding: 15px;
  width: auto;
  float: left;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
::ng-deep .page-title h3 {
  color: #666 !important;
  font-weight: bold !important;
}
::ng-deep .page-title .icon {
  display: flex;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  flex-wrap: wrap;
}
::ng-deep .page-title .icon i {
  margin-right: 5px;
  flex-shrink: 0;
}

.page-header-contents {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding: 5px 0;
}

@media screen and (max-width: 945px) {
  :host {
    min-height: auto;
    height: auto;
  }
  .navbar {
    flex-wrap: wrap;
  }
  .navbar .col-2 {
    flex: 0 0 auto;
    width: auto;
  }
  .navbar .col {
    flex: 1 1 auto;
    min-width: 0;
  }
  .page-header-contents {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
    gap: 15px;
  }
  ::ng-deep .page-title {
    width: 100%;
    float: none;
    padding: 10px 15px;
    min-height: auto;
  }
  ::ng-deep .page-title .icon {
    white-space: normal;
    line-height: 1.4;
    font-size: 0.9rem;
    word-break: break-word;
  }
  ::ng-deep .page-title .icon i {
    margin-right: 5px;
    flex-shrink: 0;
  }
  ::ng-deep .pull-right {
    width: 100% !important;
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin: 0 !important;
  }
  ::ng-deep .pull-right > span {
    width: 100% !important;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  ::ng-deep .pull-right .radio-group {
    width: 100% !important;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  ::ng-deep .pull-right .radio-group .radio {
    width: 100%;
    margin: 0;
  }
  ::ng-deep .right-menu {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  ::ng-deep .right-menu .tab-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    justify-content: flex-start;
  }
  ::ng-deep .right-menu .tab-list li {
    flex: 0 0 auto;
    min-width: 40px;
    padding: 8px;
  }
}
@media screen and (min-width: 946px) and (max-width: 1024px) {
  .page-header-contents {
    flex-wrap: wrap;
    gap: 15px;
  }
  ::ng-deep .page-title {
    flex: 0 0 auto;
  }
  ::ng-deep .pull-right {
    flex: 1 1 auto;
    min-width: 200px;
  }
}
@media screen and (max-width: 480px) {
  ::ng-deep .page-title {
    padding: 8px 10px;
    font-size: 0.85rem;
  }
  ::ng-deep .page-title .icon {
    font-size: 0.85rem;
  }
  ::ng-deep .pull-right .radio-group .radio label {
    font-size: 0.8rem !important;
  }
  ::ng-deep .right-menu .tab-list li {
    min-width: 35px;
    padding: 6px;
    font-size: 0.9rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/page-header/page-header.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EAEI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACJ;AAAI;EACA,sBAAA;EACA,4BAAA;AAEJ;AAAG;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAEL;AADK;EACE,iBAAA;EACA,cAAA;AAGP;;AACA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAEJ;;AAEA;EACE;IACE,gBAAA;IACA,YAAA;EACF;EAEA;IACE,eAAA;EAAF;EAEE;IACE,cAAA;IACA,WAAA;EAAJ;EAGE;IACE,cAAA;IACA,YAAA;EADJ;EAKA;IACE,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,SAAA;EAHF;EAMA;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,gBAAA;EAJF;EAME;IACE,mBAAA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;EAJJ;EAMI;IACE,iBAAA;IACA,cAAA;EAJN;EASA;IACE,sBAAA;IACA,wBAAA;IACA,sBAAA;IACA,SAAA;IACA,oBAAA;EAPF;EASE;IACE,sBAAA;IACA,oBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAPJ;EAUE;IACE,sBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EARJ;EAUI;IACE,WAAA;IACA,SAAA;EARN;EAaA;IACE,WAAA;IACA,aAAA;IACA,2BAAA;EAXF;EAaE;IACE,aAAA;IACA,eAAA;IACA,SAAA;IACA,WAAA;IACA,2BAAA;EAXJ;EAaI;IACE,cAAA;IACA,eAAA;IACA,YAAA;EAXN;AACF;AAiBA;EACE;IACE,eAAA;IACA,SAAA;EAfF;EAkBA;IACE,cAAA;EAhBF;EAmBA;IACE,cAAA;IACA,gBAAA;EAjBF;AACF;AAqBA;EACE;IACE,iBAAA;IACA,kBAAA;EAnBF;EAqBE;IACE,kBAAA;EAnBJ;EA0BM;IACE,4BAAA;EAxBR;EAgCI;IACE,eAAA;IACA,YAAA;IACA,iBAAA;EA9BN;AACF","sourcesContent":[":host{\n    margin:0px 0px;\n    min-height:60px;\n    height:auto;\n    width:100%;\n}\n::ng-deep .page-title \n{\n    min-height: 50px;\n    padding: 15px;\n    width:auto;\n    float: left;\n    display: flex;\n    align-items: center;\n    gap:1rem;\n    flex-wrap: wrap;\n    h3{\n    color:#666 !important;\n    font-weight: bold !important;\n   }\n   .icon {\n     display: flex;\n     align-items: center;\n     white-space: nowrap;\n     cursor: pointer;\n     flex-wrap: wrap;\n     i {\n       margin-right: 5px;\n       flex-shrink: 0;\n     }\n   }\n}\n.page-header-contents{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 5px 0;\n}\n\n// Responsive styles for mobile devices (up to 945px)\n@media screen and (max-width: 945px) {\n  :host {\n    min-height: auto;\n    height: auto;\n  }\n\n  .navbar {\n    flex-wrap: wrap;\n    \n    .col-2 {\n      flex: 0 0 auto;\n      width: auto;\n    }\n    \n    .col {\n      flex: 1 1 auto;\n      min-width: 0;\n    }\n  }\n\n  .page-header-contents {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 10px;\n    gap: 15px;\n  }\n\n  ::ng-deep .page-title {\n    width: 100%;\n    float: none;\n    padding: 10px 15px;\n    min-height: auto;\n    \n    .icon {\n      white-space: normal;\n      line-height: 1.4;\n      font-size: 0.9rem;\n      word-break: break-word;\n      \n      i {\n        margin-right: 5px;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  ::ng-deep .pull-right {\n    width: 100% !important;\n    display: flex !important;\n    flex-direction: column;\n    gap: 10px;\n    margin: 0 !important;\n    \n    > span {\n      width: 100% !important;\n      margin: 0 !important;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n    }\n\n    .radio-group {\n      width: 100% !important;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n      \n      .radio {\n        width: 100%;\n        margin: 0;\n      }\n    }\n  }\n\n  ::ng-deep .right-menu {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    \n    .tab-list {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n      width: 100%;\n      justify-content: flex-start;\n      \n      li {\n        flex: 0 0 auto;\n        min-width: 40px;\n        padding: 8px;\n      }\n    }\n  }\n}\n\n// Tablet styles (946px to 1024px)\n@media screen and (min-width: 946px) and (max-width: 1024px) {\n  .page-header-contents {\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n\n  ::ng-deep .page-title {\n    flex: 0 0 auto;\n  }\n\n  ::ng-deep .pull-right {\n    flex: 1 1 auto;\n    min-width: 200px;\n  }\n}\n\n// Small mobile devices\n@media screen and (max-width: 480px) {\n  ::ng-deep .page-title {\n    padding: 8px 10px;\n    font-size: 0.85rem;\n    \n    .icon {\n      font-size: 0.85rem;\n    }\n  }\n\n  ::ng-deep .pull-right {\n    .radio-group {\n      .radio {\n        label {\n          font-size: 0.8rem !important;\n        }\n      }\n    }\n  }\n\n  ::ng-deep .right-menu {\n    .tab-list {\n      li {\n        min-width: 35px;\n        padding: 6px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
